import { render, staticRenderFns } from "./TransProgramLowIncomeIndContent.vue?vue&type=template&id=be825036&scoped=true"
import script from "./TransProgramLowIncomeIndContent.vue?vue&type=script&lang=ts"
export * from "./TransProgramLowIncomeIndContent.vue?vue&type=script&lang=ts"
import style0 from "./TransProgramLowIncomeIndContent.vue?vue&type=style&index=0&id=be825036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be825036",
  null
  
)

export default component.exports